/**
 * Default sidebar page allowlist for newly-created Viewer users.
 *
 * Mirrors the SQL backfill in
 * `supabase/migrations/20260427100000_add_viewer_visible_pages.sql` so a
 * fresh Viewer (created post-migration) sees the same nav items an existing
 * Viewer does. Adding a page that should be on by default for new Viewers
 * means updating both the migration and this list.
 *
 * Frontend's page registry (`apps/frontend/src/lib/page-registry.ts`)
 * imports this so the picker can pre-check the right boxes.
 */
export const DEFAULT_VIEWER_PAGES = [
    'inventory',
    'products',
    'orders',
    'shipments',
    'suppliers',
    'stock-alerts',
    'consumables',
    'logs',
    'reporting',
];
